export function getFriendlyId(value: string) {
    return value.toLowerCase().replaceAll("/", "_").replaceAll(" ", "_");
}
